import {gsap} from "gsap";

export const animationsFunc = () => {
   // const btnsPrimary = document.querySelectorAll(".btn-primary");
   const throttled = (delay, fn) => {
      let lastCall = 0;
      return function (...args) {
         const now = new Date().getTime();
         if (now - lastCall < delay) {
            return;
         }
         lastCall = now;
         return fn(...args);
      };
   };

   const movableElements = document.querySelectorAll(".movable");
   const mouseMoveHandler2 = (e) => {
      movableElements.forEach((movableElement) => {
         const shiftValue = movableElement.getAttribute("data-move");
         const moveX = (e.clientX * shiftValue) / 250;
         const moveY = (e.clientY * shiftValue) / 250;

         gsap.to(movableElement, {x: moveX, y: moveY, duration: 1});
      });
   };

   const tHandler = throttled(200, mouseMoveHandler2);
   addEventListener("mousemove", tHandler);
};